import { SEO, ContactForm } from "../components";

export const Contact = (props) => {
  const { config, project } = props;
  const seo = config?.SEO.contact;

  return (
    <div id="ContactPage" className="contact-page">
      <SEO
        title={seo?.title}
        description={seo?.description}
        keywords={seo?.keywords}
        ogImage={`/assets/og_image/${project}.jpg`}
      />
      <ContactForm projectTitle={config?.title} />;
    </div>
  );
};
